import React, { useEffect, useMemo, useRef, useState } from "react";
import smartWatch from "../../Images/smartWatch.gif";
import tws from "../../Images/tws.gif";
import router from "../../Images/router.gif";
import kettle from "../../Images/kettle.gif";
import useParts from "../../hooks/useParts";
import CategoryDetail from "./CategoryDetail";
import Loading from "../Shared/Loading";

const Category = () => {
  const [carParts, isLoading] = useParts();
  const newItems = [...carParts];
  const [searchTerm, setSearchTerm] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const products = useMemo(() => [...filteredProducts], [filteredProducts]);

  let categoryProducts = newItems.sort();
  const targetDivRef = useRef(null);

  const handleSearch = (category) => {
    setSearchTerm(true);
    setSearch(category);
    if (targetDivRef.current) {
      targetDivRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (searchTerm === true) {
      setFilteredProducts(
        categoryProducts.filter((product) =>
          product.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search, searchTerm, categoryProducts]);

  if (isLoading) {
    <Loading></Loading>;
  }

  return (
    <div style={{ fontFamily: "Roboto" }} className="text-accent">
      <h1 className="lg:text-5xl text-4xl text-accent text-center font-bold mt-10 capitalize">
        Categories of our products
      </h1>

      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-10 mx-8">
        <div className="card card-compact md:w-72 w-40 mx-auto shadow-xl p-5 rounded-md font-bold bg-neutral">
          <h2 className="text-lg text-center pb-2">Smart Watch</h2>
          <button onClick={() => handleSearch("SmartWatch")}>
            <figure>
              <img
                className="h-100 md:h-100 w-72 md:w-72 hover:scale-110 hover:duration-500"
                src={smartWatch}
                alt="Shoes"
              />
            </figure>
            <div class="card-body">
              <h3 className="text-sm text-center hover:text-primary ">
                Shop Now
              </h3>
            </div>
          </button>
        </div>
        <div className="card card-compact md:w-72 w-40 card-body text-accent   mx-auto shadow-xl   p-5 rounded-md font-bold bg-neutral">
          <h2 className="text-lg text-center pb-2">TWS</h2>
          <button onClick={() => handleSearch("tws")}>
            <figure>
              <img
                className="h-100 md:h-100 w-72 md:w-72 hover:scale-110 hover:duration-500"
                src={tws}
                alt="Shoes"
              />
            </figure>
            <div class="card-body ">
              <h3 className="text-sm text-center hover:text-primary ">
                Shop Now
              </h3>
            </div>
          </button>
        </div>
        <div className="card card-compact md:w-72 w-40 card-body text-accent   mx-auto shadow-xl   p-5 rounded-md font-bold bg-neutral">
          <h2 className="text-lg text-center pb-2">Router</h2>
          <button onClick={() => handleSearch("router")}>
            <figure>
              <img
                className="h-100 md:h-100 w-72 md:w-72 hover:scale-110 hover:duration-500"
                src={router}
                alt="Shoes"
              />
            </figure>
            <div class="card-body ">
              <h3 className="text-sm text-center hover:text-primary ">
                Shop Now
              </h3>
            </div>
          </button>
        </div>
        <div className="card card-compact md:w-72 w-40 card-body text-accent   mx-auto shadow-xl   p-5 rounded-md font-bold bg-neutral">
          <h2 className="text-lg text-center pb-2">Kettle</h2>
          <button onClick={() => handleSearch("kettle")}>
            <figure>
              <img
                className="h-100 md:h-100 w-72 md:w-72 hover:scale-110 hover:duration-500"
                src={kettle}
                alt="Shoes"
              />
            </figure>
            <div class="card-body ">
              <h3 className="text-sm text-center hover:text-primary ">
                Shop Now
              </h3>
            </div>
          </button>
        </div>
      </div>
      {products && (
        <div
          ref={targetDivRef}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-5 text-black mt-10"
        >
          {products.map((categoryProducts) => (
            <CategoryDetail
              key={categoryProducts._id}
              categoryProducts={categoryProducts}
            ></CategoryDetail>
          ))}
        </div>
      )}
    </div>
  );
};

export default Category;
